function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import useStyles from "./style";
var Tooltip = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;
  var children = props.children;
  return /*#__PURE__*/React.createElement(AntdTooltip, _extends({}, props, {
    ref: ref,
    overlayClassName: cx(prefixCls + '-custom-tooltip', styles.customTooltip, props.overlayClassName)
  }), children);
});
Tooltip.displayName = 'Tooltip';
export default Tooltip;